import React, { ReactElement, RefAttributes } from 'react';

import {
  CircleButtonStylesProps as StylesProps,
  CircleButton as CircleButtonStyled,
  ButtonIcon,
  ButtonTitle,
} from './CircleButtonStyles';

type Props = {
  id?: string;
  className?: string;
  disabled?: boolean;
  icon: ReactElement<any, any>;
  title?: string;
  onClick?: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
} & Partial<StylesProps> &
  RefAttributes<HTMLButtonElement>;

export const CircleButton: React.FC<Props> = React.forwardRef<
  HTMLButtonElement,
  Props
>(({ id, className, disabled = false, title, icon, onClick, ...rest }, ref) => {
  return (
    <CircleButtonStyled
      id={id}
      ref={ref}
      disabled={disabled}
      className={className}
      onClick={!disabled ? onClick : () => null}
      {...rest}
    >
      <ButtonIcon disabled={disabled}>{icon}</ButtonIcon>
      {title && <ButtonTitle>{title}</ButtonTitle>}
    </CircleButtonStyled>
  );
});
